import React from 'react'

import Translator from 'bazinga-translator'
import Button from 'components/Btn'
import withCondition from 'components/withCondition'
import { GameWithUserInformation } from 'containers/GamesBlock/types'
import { getLoginUrlWithRedirect } from 'utils/url'

interface Props {
  game: GameWithUserInformation
}

function LoginAndPlayButtonComponent({ game }: Props) {
  const { realPlayUrl } = game

  return (
    <Button
      md
      secondary
      to={getLoginUrlWithRedirect(realPlayUrl)}
    >
      {Translator.trans('login and play', {}, 'games')}
    </Button>
  )
}

export const LoginAndPlayButton = withCondition(LoginAndPlayButtonComponent)
